import React from 'react';
import PropTypes from 'prop-types';

import { sendReactError } from 'services/app-service';
import { getLogoURL } from 'components/utils/app';
import { userAgent } from 'components/utils/device';

import './ErrorBoundary.scss';

const today = new Date();
const year = today.getFullYear();

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  async componentDidCatch(error, info) {
    this.setState({ hasError: true });
    const module = await import(/* webpackChunkName: "stacktrace-js" */ 'stacktrace-js');
    const StackTrace = module.default;
    const stackFrames = await StackTrace.fromError(error);
    await sendReactError({
      type: 'React boundary',
      error: error.message,
      version: global.version,
      parsedStack: stackFrames ? stackFrames.map(sf => sf.toString()).join('\n') : '',
      componentStack: info ? info.componentStack : '',
      url: window ? window.location.href : '',
      agent: userAgent,
      date: new Date(),
      dimensions: {
        width: window ? window.innerWidth : '',
        height: window ? window.innerHeight : ''
      }
    });
  }

  reloadApp() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="SSR-server-main">
          <header>
            <a href="/" title="Home" className="header-logo">
              <img src={getLogoURL()} alt="Birthday Alarm" width="189" height="31" />
            </a>
          </header>
          <section className="SSR-server-contents">
            <br/>
            <br/>
            <br/>
            <h1 className="server-title">Oops, sorry</h1>
            <p className="server-subtitle">Something went wrong on our end</p>
            <br/>
            <p className="server-button" onClick={this.reloadApp}>Reload App</p>
          </section>
          <footer>
            <p>© 2001-{year} birthdayalarm.com</p>
          </footer>
        </main>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundary;
